import { useForm } from 'react-hook-form';

import { zodResolver } from '@hookform/resolvers/zod';
import { z } from 'zod';

import { FormBlock } from '@/components/FormBlock';
import { useZustandSync } from '@/hooks/useZustandSync';
import { productStore } from '@/stores/productStore';

import Checkbox from '../form/Checkbox';
import { ErrorMessage } from '../form/ErrorMessage';
import { HelpText } from '../ui/HelpText';

const fiscalTermsSchema = z.object({
  producerFiscalTerm: z.boolean().refine(val => val === true, {
    message: 'Você deve aceitar os termos de uso para continuar'
  })
});

type FiscalTermsFormValues = z.infer<typeof fiscalTermsSchema>;

const FIELD_NAME = 'producerFiscalTerm';

export default function FiscalTerm() {
  const form = useForm<FiscalTermsFormValues>({
    resolver: zodResolver(fiscalTermsSchema),
    mode: 'onChange',
    defaultValues: { producerFiscalTerm: productStore.getState().producer.fiscalTerm ?? false }
  });

  useZustandSync<FiscalTermsFormValues>(form.control, (data, current) => ({
    producer: {
      ...(current.producer || {}),
      fiscalTerm: data.producerFiscalTerm
    }
  }));

  return (
    <FormBlock name='producer-fiscal-term' form={form} title='Termo de responsabilidade fiscal'>
      <Checkbox id={FIELD_NAME} name={FIELD_NAME}>
        Aceito o termo de responsabilidade fiscal
      </Checkbox>
      <ErrorMessage fieldName={FIELD_NAME} />
      <HelpText>
        Declaro ser o único responsável por manter em dia os pagamentos de meus tributos referentes a valores recebidos
        da Atividade de Divulgação de Produtos Digitais, não cabendo, portanto, qualquer responsabilidade à Eduzz Ensino
        a Distância Ltda ou aos produtores dos Conteúdos que estou divulgando.
      </HelpText>
    </FormBlock>
  );
}
